import '../App.css';
import '../css/Nav design.css';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import RegisteredUserData from '../model/response/RegisteredUserData';
import { ToastContainer, toast } from "react-toastify";
import AdminRequest from '../model/request/AdminRequest';
import AdminResponse from '../model/response/AdminResponse';
import TopBarLogin from './TopBarLogin';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import Offeradd from './Offeradd.js';
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Adminlogin() {
  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;


  const navigation = useNavigate()

  var [username, setUsername] = useState("");
  var [usernameError, setusernameError] = useState()
  var [password, setPassword] = useState("")
  var [passwordError, setpasswordError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [profile, SetProfile] = useState({});
   const [showPassword, setShowPassword] = useState(false);



  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  function clicktoDashboardscreen() {

    if (validation()) {
      AdminAPICall();
    }
  }
  useEffect(() => {
    if (loginVal) {
      if (Number(loginVal.role) === 1) {
        navigation('/Dashboard');
      } else {
        //showToastFailed("Users are not allowed to access the Admin login page.");
        navigation('/Viewpage');
      }
    }
  }, [navigation]);


  function validation() {
    var isFlage = true
    {
      if (username == "") {
        setusernameError("Please enter your username")
        isFlage = false
      }
      else {
        setusernameError("")
      }
      if (password == "") {
        setpasswordError("Please enter your password")
        isFlage = false
      }
      else {
        setpasswordError("")
      }
      return isFlage;
    }
  }

  function AdminAPICall() {
    setIsLoading(true);
    var request = new AdminRequest();
    request.user_Name = username;
    request.password = password;
    axios.post(
      ApiConfig.getUrl("User/adminlogin"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(response => {
        console.log("Response:", response.data);
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        if (api.statusCode == 200) {
          const profileVal = AdminResponse.fromJson(api.response);
          SetProfile(profileVal);
          showToast(api.message);
          setTimeout(() => {
            setIsLoading(false);
            localStorage.setItem("token", profileVal.token)
            localStorage.setItem("loginVal", JSON.stringify(api.response));
            localStorage.setItem("loginVal", JSON.stringify({ ...api.response, role: Number(api.response.role) }));
            console.log("statusCode:", profileVal.token);
            navigation('/Dashboard', { state: { role: profileVal.role } });
          }, 500);

        } else {
          setIsLoading(false);
          showToastFailed(api.errorMessage);
        }
      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed(error);
        console.error("Error:", error);
      });
  }
  const disableRightClick = (e) => {
    e.preventDefault();
  };



  return (
    <>
      <div className='fullview' onContextMenu={disableRightClick}>
        <ToastContainer />


        {isLoading && (
          <div className="loader-overlay">
            <Oval
              height={60}
              width={60}
              color="#ffffff"
              secondaryColor="#cccccc"
              strokeWidth={4}
              visible={true}
            />
          </div>
        )}
        <div className='container'>

          <div className='row mt-5 align-items-center gx-0'>
            <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
              <img className='logo_design' src={logo} alt='logo' />
            </div>



            <div className="col-lg-6 col-12 card  p-3">
              <p className="title-text">Admin Login</p>

              <label htmlFor="uname">Username </label>
              <input type="text" id="uname" placeholder="Enter your Username" className="form-control pe-5 mt-1 mb-1" onChange={(e) => setUsername(e.target.value)} value={username} />
              <span className='input-error'>{usernameError}</span>
             


              <label className='mt-2' htmlFor="pass">Password</label>
              <div className="position-relative mb-2">
                <input  type={showPassword ? "text" : "password"} id="pass" placeholder="password" className="form-control pe-5 mt-1 mb-1" onChange={(e) => setPassword(e.target.value)} value={password} />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#6c757d"
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <span className='input-error'>{passwordError}</span>


              <button onClick={clicktoDashboardscreen} type="button" className="btn w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}> Submit </button>


            </div>

          </div>
        </div>
      </div>
      <footer className='bg-dark text-white text-center '>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>


  );
}
export default Adminlogin;